import React, { useState, useEffect, useRef } from "react";
import { viewIcon } from "../../Icons/Icons";
import EmployeePayslipData from "./EmployeePayslipData";
import { PAYROLL_STATUS } from "../../../src/redux/constants/payrollComponents";

const EmployeePayrollData = ({
  employeeList = [],
  selectedEmployees = [],
  setSelectedEmployees = () => {},
  year,
  month,
}) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isPayslipViewOpen, setIsPayslipViewOpen] = useState(false);
  const selectAllRef = useRef();
  const allSelected =
    employeeList.length > 0 &&
    employeeList.every((emp) => selectedEmployees.includes(emp?.employee_id));

  const isIndeterminate = selectedEmployees.length > 0 && !allSelected;

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  const handleEmployeeSelect = (id, isChecked) => {
    if (isChecked) {
      setSelectedEmployees((prev) => [...prev, id]);
    } else {
      setSelectedEmployees((prev) => prev.filter((empId) => empId !== id));
    }
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const allIds = employeeList.map((emp) => emp.employee_id);
      setSelectedEmployees(allIds);
    } else {
      setSelectedEmployees([]);
    }
  };

  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setIsPayslipViewOpen(true);
  };

  const handleClosePayslipView = () => {
    setSelectedEmployee(null);
    setIsPayslipViewOpen(false);
  };

  if (isPayslipViewOpen && selectedEmployee) {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 overflow-auto">
        <div className="bg-white rounded-lg shadow-lg max-w-5xl w-full max-h-[90vh] overflow-y-auto">
          <EmployeePayslipData
            employee={selectedEmployee}
            onClose={handleClosePayslipView}
            selectedEmployeeIds={selectedEmployees}
            employeeList={employeeList}
            setSelectedEmployeeIds={setSelectedEmployees}
            year={year}
            month={month}
          />
        </div>
      </div>
    );
  }
const getPayrollStatusClass = (status) => {
  switch (status) {
    case PAYROLL_STATUS.PUBLISHED:
      return "status--green"; 
    case PAYROLL_STATUS.GENERATED:
      return "status--orange";
    case PAYROLL_STATUS.PENDING:
      return "status--gray";
    default:
      return "status--yellow";
  }
};


  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm text-gray-500">
        <thead className="text-xs font-medium uppercase bg-gray-50 text-[#4B5563] border-b border-t tracking-wider">
          <tr>
            <th className="px-6 py-3 text-center border-r">
              <input
                type="checkbox"
                ref={selectAllRef}
                checked={allSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
            </th>
            <th className="px-6 py-3 text-left border-r">Employee Serial</th>
            <th className="px-6 py-3 text-left border-r">Employee</th>

            <th className="px-6 py-3 text-center border-r">Status</th>
            <th className="px-6 py-3 text-center sticky right-0 bg-gray-50 z-20 border-r">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {employeeList.length > 0 ? (
            employeeList.map((emp, index) => {
              const empName = `${emp.first_name} ${emp.last_name}`;
              return (
                <tr key={index} className="bg-white border-b text-center">
                  <td className="px-6 py-4">
                    <input
                      type="checkbox"
                      checked={selectedEmployees.includes(emp.employee_id)}
                      onChange={(e) =>
                        handleEmployeeSelect(emp.employee_id, e.target.checked)
                      }
                    />
                  </td>
                  <td className="px-6 py-4 text-left">
                    {emp?.employee_serial}
                  </td>
                  <td className="px-6 py-4 text-left">{empName}</td>

                  <td className="px-6 py-4">
                    <span
                      className={`status ${getPayrollStatusClass(
                        emp?.payroll_status
                      )}`}
                    >
                      {emp?.payroll_status || "N/A"}
                    </span>
                  </td>

                  <td className="px-6 py-4 sticky right-0 bg-white z-10">
                    <div className="flex items-center justify-center gap-5">
                      <button onClick={() => handleViewClick(emp)}>
                        {viewIcon}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-4">
                No employee data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeePayrollData;
